/* global AWS:true */
export const AwsObject = (currentEnvironment) => {
  var config = {
    accessKeyId: currentEnvironment.s3AccessKeyId,
    secretAccessKey: currentEnvironment.s3SecretAccessKey
  }
  AWS.config.update(config)
  AWS.config.region = currentEnvironment.s3Region
}



// WEBPACK FOOTER //
// ./src/app/institution/aws.js